import {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import propertyApi from "../../../services/propertyApi";
import FormLayout from "../../../componets/layout/FormLayout";
import bannersApi from "../../../services/bannersApi";
import Input from "../../../componets/inputs/Input";
import InputCurrency from "../../../componets/inputs/inputCurrency";
import ImageButton from "../../../componets/button/ImageButton";
import {RiImageAddFill} from "react-icons/ri";
import {IoClose} from "react-icons/io5";

export default function FormBanners() {
    const defaltValues = {
        id: '',
        nome: '',
        image: '',
        url_path: '',
    }
    const [state, setState]: any = useState(defaltValues);
    const params = useParams();
    const [loading, setLoading] = useState(true);

    const [imagesScreen, setImagesScreen]: any = useState([]);
    const [imageRemove, setImageRemove] = useState([]);

    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };

    const onSelectImages = async (data: any) => {
        const urlPath: string = URL.createObjectURL(data[0]);
        const newState = {...state}
        let imagesbase64: any[] = []

        data.map((img: any) => {
            convertFileToBase64(img, (str: any) => imagesbase64.push({
                url_path: str,
                original_name: img.name
            }))
        })


        setImagesScreen(urlPath);
        newState.image = imagesbase64;

        setState(newState);
    }

    const onRemoveImg = async () => {
        const newState = {...state}

        newState.url_path = '';
        newState.image = '';
        setState(newState);
        setImagesScreen('');

    }

    function convertFileToBase64(file: any, callback: any, originalName?: boolean) {

        const reader = new FileReader();
        reader.readAsDataURL(file);
        if (originalName){
            reader.onloadend = () => callback({
                file: reader.result,
                original_name: file.name
            });
        }else{
            reader.onloadend = () => callback(reader.result);
        }

    }

    const getDatas = async () => {
        if (params.id){
            const {data, isError} = await bannersApi.one(params.id);
            if (!isError){
                setState(data);
                setImagesScreen(data.image_path)
            }
        }
        setLoading(false)
    }

    useEffect(() => {
        if (params.id){
            getDatas();
        }else{
            setLoading(false)
        }
    }, []);

    return(
        <FormLayout
            title={'Cadastro de Banner'}
            urlReturn={'/banners/lista'}
            state={state}
            setState={setState}
            apiData={bannersApi}
            defaltValues={defaltValues}
        >
            {
                loading ?
                    <span className="flex items-center justify-center h-7">
                        <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-black"
                             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </span>
                    :
                    <div className={'flex md:flex-row w-full md:p-4 xs:p-1'}>
                        <div className={'w-full grid'}>
                            <div className="grid grid-cols-12 gap-5 mb-4">
                                <Input
                                    required
                                    label={'Nome'}
                                    value={state.nome}
                                    className={'md:col-span-3 xs:col-span-12'}
                                    setValue={(v) => handleChange(v, 'nome')}
                                />
                                <div className={'md:col-span-12 xs:col-span-12 flex gap-4 items-center content-center md:pt-5 content-center text-[25px] text-system-primary'}>
                                    <ImageButton
                                        multiple={false}
                                        onSelect={(e: any) => onSelectImages(e)}
                                        id={'images-vehicles'}
                                        icon={<RiImageAddFill/>}
                                        accept={'image/*'}
                                    />

                                </div>


                            </div>
                            {

                                imagesScreen.length ?
                                    <div className={'flex flex-wrap gap-3'}>
                                        <div className={'border-2 border-border p-1 rounded-md relative'}>
                                            <button type={'button'} onClick={() => onRemoveImg()} className={'w-[20px] h-[20px] absolute text-system-primary top-1  rounded-full justify-center'}>
                                                <IoClose/>
                                            </button>
                                            <img className={'h-48 w-96 '} src={imagesScreen}/>
                                        </div>

                                    </div>
                                    :''
                            }


                        </div>

                    </div>
            }
        </FormLayout>
    )
}